import { render, staticRenderFns } from "./TruncatedResponseModal.vue?vue&type=template&id=72863035&scoped=true&"
import script from "./TruncatedResponseModal.vue?vue&type=script&lang=js&"
export * from "./TruncatedResponseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72863035",
  null
  
)

export default component.exports